<template>
  <div class="masthead">
    <div class="grid grid--container">
      <div class="masthead__content">
        <VText class="masthead__title" variant="h1"
          >Create your space on the web</VText
        >
        <div class="masthead__text">
          <VText
            >Convert more followers into customers with a link in bio tool
            created just for you.</VText
          >
        </div>
        <Button
          class="masthead__btn"
          size="large"
          href="https://app.campsite.bio/create-account"
          color="secondary"
          variant="hard-shadow"
        >
          Get Started for Free
        </Button>

        <div class="masthead__line" ref="line"></div>
      </div>
      <ProfileAnimation :line="line" />
    </div>
  </div>
</template>

<script>
import { VText, Button } from '@campsite-bio/component-lib';
import { ref } from '@nuxtjs/composition-api';

import ProfileAnimation from '@/components/home/masthead/profile-animation';

export default {
  components: {
    VText,
    ProfileAnimation,
    Button,
  },

  setup() {
    const line = ref(null);
    return { line };
  },
};
</script>

<style lang="scss" scoped>
.masthead {
  background: var(--g-color-gray-100);
  background-image: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1)
    ),
    url('~assets/images/mark-pattern-white.svg');
  background-size: auto, 80px auto;

  padding-bottom: 3rem;
  padding-top: 3rem;
  overflow: hidden;
  text-align: center;

  .grid {
    align-items: center;
    display: grid;

    // @media (min-width: 992px) {
    //   gap: 2rem;
    //   grid-template-columns: 425px 1fr;
    // }

    // @media (min-width: 1100px) {
    //   grid-template-columns: 500px 1fr;
    // }
  }

  &__content {
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;

    @media (min-width: 992px) {
      margin-bottom: 3rem;
    }
  }

  &__text {
    margin-bottom: 1.5rem;

    @media (min-width: 992px) {
      margin-bottom: 2.5rem;
    }

    p {
      font-size: 1.15rem;
      margin-bottom: 0.75em;

      @media (min-width: 768px) {
        font-size: 1.5rem;
      }
    }
  }

  &__line {
    background: var(--g-color-gray-500);
    width: 3px;
    height: 3rem;
    margin: 1rem auto;
    transform-origin: top center;
    transform: scaleY(0);

    @media (min-width: 992px) {
      display: none;
    }
  }
}

.masthead__title.masthead__title {
  margin-bottom: 1rem;
  font-size: 2rem;

  @media (min-width: 992px) {
    font-size: 2.45rem;
  }
}
</style>
